<template>
    <component :is="display" />
</template>

<script>
import Dashboard from "@/pages/console/Dashboard.vue";
import PortfolioList from "@/pages/console/portfolio/portfolio-list.vue";
import CompanyView from "@/pages/console/company/CompanyView.vue";
import TechnicianView from "../client/partners/TechnicianView.vue";

export default {
    components: {
        Dashboard,
        PortfolioList,
        CompanyView,
        TechnicianView,
    },
    mounted() {
        if (this.scopeIncludes("console") || this.scopeIncludes("store") || this.scopeIncludes("interior")) {
        } else if (this.scopeIncludes("company")) this.$router.push(`/console/company/${this.payload._user}`);
        else if (this.scopeIncludes("technician")) this.$router.push(`/console/technicians/${this.payload._user}`);
        else if (this.scopeIncludes("measurer")) this.$router.push(`/console/estimate/inquiries`);
        else this.$router.go(-1);
    },
    methods: {
        scopeIncludes(criterion) {
            return this.payload.scope.includes(criterion);
        },
    },
    computed: {
        payload() {
            return this.$store.state.payload || {};
        },
        scope() {
            return this.payload.scope || [];
        },
        display() {
            if (this.scopeIncludes("console")) return "dashboard";
            else if (this.scopeIncludes("store")) return "dashboard";
            else if (this.scopeIncludes("interior")) return "portfolio-list";
            // else if (this.scopeIncludes("company")) return "company-view";
            else if (this.scopeIncludes("technician")) return "technician-view";
            else return null;
        },
    },
};
</script>
